function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

export async function displayPaytm(
  { txnToken, orderId, mid, amount, websiteName, email, phone },
  submitHandler
) {
 

  // Determine script URL based on websiteName
  // websiteName "WEBSTAGING" implies staging environment
  const isStaging = websiteName === "WEBSTAGING";
  

  const host = isStaging
    ? "securestage.paytmpayments.com"
    : "secure.paytmpayments.com";
  // The Checkout JS library URL
  const scriptSrc = `https://${host}/merchantpgpui/checkoutjs/merchants/${mid}.js`;

 

  const res = await loadScript(scriptSrc);

  if (!res) {
    console.error("Paytm SDK failed to load from", scriptSrc);
    alert("Paytm SDK failed to load. Are you online? Invalid MID?");
    submitHandler({
      isDone: true,
      status: false,
      message: "Paytm SDK failed to load.",
    });
    return;
  }

 

  const config = {
    root: "",
    flow: "DEFAULT",
    data: {
      orderId: orderId,
      token: txnToken,
      tokenType: "TXN_TOKEN",
      amount: amount.toString(),
      email: email || "",
      mobileNumber: phone || "",
    },
    handler: {
      notifyMerchant: function (eventName, data) {
        if (eventName === "APP_CLOSED") {
          submitHandler({
            isDone: true,
            status: false,
            message: "Payment popup closed.",
          });
        }
      },
    },
  };

 

  if (window.Paytm && window.Paytm.CheckoutJS) {
    window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
    
      // initialze configuration using init method
      window.Paytm.CheckoutJS.init(config)
        .then(function onSuccess() {
         
          // after successfully updating configuration, invoke JS Checkout
          window.Paytm.CheckoutJS.invoke();
        })
        .catch(function onError(error) {
        
          alert("Paytm initialization failed. Check console for details.");
          submitHandler({
            isDone: true,
            status: false,
            message: "Paytm initialization failed.",
          });
        });
    });
  } else {
    console.error("window.Paytm or window.Paytm.CheckoutJS is missing");
    alert("Paytm SDK not available.");
    submitHandler({
      isDone: true,
      status: false,
      message: "Paytm SDK not available.",
    });
  }
}
